import type {ExpressionPath} from '@packages/systems/wfdl';

export const INHERIT_IMAGE_ALT_VALUE = '__wf_reserved_inherit';

export const reservedImageAltValues = [
  INHERIT_IMAGE_ALT_VALUE,
  '__wf_reserved_decorative',
];

export const ALT_PATH: ExpressionPath = [
  {in: 'Record', at: 'attr'},
  {in: 'Record', at: 'alt'},
];
